<script>
	import { pageOffset } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';

	let _fish;
	let inView = false;
	let start = 0;
	let scrollDirectionDown = true;
	let scrolledBefore = 0;
	export let direction = 'ltr';
	export let size;
	export let left;
	export let top;
	export let speedMultiplier;
	let swimRotation;

	let animation = (value) => {
		animateElement(value, _fish, (currentPageOffset) => {
			if (!inView) {
				start = currentPageOffset;
				inView = true;
			}
			scrollDirectionDown = scrolledBefore < currentPageOffset;
			scrolledBefore = currentPageOffset;
			const elmentInViewPercentage = (currentPageOffset - start) * 100 / window.innerHeight;

			_fish.style.transform = `translateX(${direction === 'ltr' ? '' : '-'}${(elmentInViewPercentage * 0.5 * speedMultiplier)}vw) rotate(${scrollDirectionDown ? swimRotation.down : swimRotation.up})`;
		});
	};

	function getOffsetTop(element) {
		if (element.offsetParent) {
			return element.offsetTop + getOffsetTop(element.offsetParent);
		}
		return element.offsetTop || 0;
	}


	let prepareScene = () => {
		if (!_fish) {
			requestAnimationFrame(prepareScene);
			return;
		}

		swimRotation = {
			down: direction === 'ltr' ? '180deg' : '0deg',
			up: direction === 'ltr' ? '0deg' : '180deg',
		};

		pageOffset.subscribe(animation);
	};

	prepareScene();

</script>

<style>
	svg {
		position: absolute;
	}
</style>

<svg bind:this={_fish} style="width: {size}; left: {left}; top: {top}" width="129" height="66" viewBox="0 0 129 66" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M30.96 66L54.5874 42.2727L77.9432 65.7273L101.299 42.2727L120.309 61.3636L129 52.6364L109.989 33.5455L110.533 33L109.989 32.1818L129 13.0909L120.309 4.36364L101.299 23.4545L77.9432 0L54.5874 23.4545L31.2316 0L0 31.3636L30.96 66ZM92.3368 33.5455L77.6716 48.2727L63.0063 33.5455L63.5495 33L63.0063 32.4545L77.6716 17.7273L92.3368 32.4545L91.7937 33L92.3368 33.5455ZM45.8968 33.5455L31.5032 48L17.1095 31.9091L31.2316 17.7273L45.8968 32.4545L45.3537 33L45.8968 33.5455Z" fill="#22398E"/>
</svg>
